import(/* webpackMode: "eager", webpackExports: ["VideoEditSidePanel"] */ "/app/apps/sb-shell/app/(main)/(dark)/ai/video-edit/_components/VideoEditSidePanel.tsx");
